import { render, staticRenderFns } from "./k-promo-reel.vue?vue&type=template&id=18e5064c&lang=pug&"
import script from "./k-promo-reel.vue?vue&type=script&lang=js&"
export * from "./k-promo-reel.vue?vue&type=script&lang=js&"
import style0 from "./k-promo-reel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18e5064c')) {
      api.createRecord('18e5064c', component.options)
    } else {
      api.reload('18e5064c', component.options)
    }
    module.hot.accept("./k-promo-reel.vue?vue&type=template&id=18e5064c&lang=pug&", function () {
      api.rerender('18e5064c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/blocks/k-promo-reel.vue"
export default component.exports